import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { Observable} from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

export class User {
  idPessoaFisica: string;
  usuario: string;
  titulo: string;
  nome: string;
  sobrenome: string;
  nomeCompleto: string;
  sigla: string;
  token?: string;
  idProfissionalSaude: string;
  numeroCertificado: number;
}
const { host } = environment;
const { client_id, redirectUri, authorization } = environment.auth;

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  public user: Observable<User>;
  public grantCode: string;
  public accessToken: string;

  private http: HttpClient;

  constructor(
    private router: Router,
    handler: HttpBackend) {

    this.http = new HttpClient(handler);
  }

  public async getGrantCode(): Promise<any> {
    const options = {
      headers: {
        client_id: client_id
      }
    };

    const body = {
      client_id: client_id,
      redirect_uri: redirectUri
    };

    return await this.http.post(`${host}/oauth/grant-code`, body, options)
      .pipe(
        retry(3),
        map((response: any) => {
          return response.redirect_uri.split('?code=')[1];
        })
      )
      .toPromise()
      .then((response: any) => {
        return this.grantCode = response;
      }).catch(err => {
        return this.grantCode = null;
      });
  }

  public async getAccessToken(): Promise<any> {

    if (this.grantCode == null || this.grantCode == undefined || this.grantCode == "")
      await this.getGrantCode();

    const options = {
      headers: {
        client_id: client_id,
        Authorization: 'Basic ' + authorization
      }
    };

    const body = {
      code: this.grantCode,
      grant_type: 'authorization_code'
    };

    return await this.http.post(`${host}/oauth/access-token`, body, options)
      .pipe(
        retry(3),
        map((response: any) => {
          return response.access_token;
        })
      )
      .toPromise()
      .then((response: any) => {
        return this.accessToken = response;
      }).catch(err => {
        return this.accessToken = null;
      });
  }

}
